import { render, staticRenderFns } from "./campaigns-stats-page.vue?vue&type=template&id=26d6629e&"
import script from "./campaigns-stats-page.vue?vue&type=script&lang=js&"
export * from "./campaigns-stats-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports